import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

// Dark-background logo variants
import nextjsDark  from '../../assets/SVG Logos/nextjs-dark-mode.svg';
import claudeCode  from '../../assets/SVG Logos/claudecode-color.svg';
import cursorDark  from '../../assets/SVG Logos/cursor-dark-mode.svg';
import expoDark    from '../../assets/SVG Logos/expo-dark-mode.svg';
import supabase    from '../../assets/SVG Logos/supabase.svg';
import githubDark  from '../../assets/SVG Logos/github-dark-mode.svg';
import typescript  from '../../assets/SVG Logos/typescript.svg';
import reactjs     from '../../assets/SVG Logos/reactjs.svg';
import openaiDark  from '../../assets/SVG Logos/openai-dark-mode.svg';
import resendDark  from '../../assets/SVG Logos/resend-dark-mode.svg';
import python      from '../../assets/SVG Logos/python.svg';
import nodejs      from '../../assets/SVG Logos/nodejs-alt.svg';
import amazonDark  from '../../assets/SVG Logos/amazon-web-services-dark-mode.svg';
import vercelDark  from '../../assets/SVG Logos/vercel-dark-mode.svg';

// Light-background logo variants (same file where no light variant exists)
import nextjsLight from '../../assets/SVG Logos/nextjs-light-mode.svg';
import cursorLight from '../../assets/SVG Logos/cursor-light-mode.svg';
import expoLight   from '../../assets/SVG Logos/expo-light-mode.svg';
import githubLight from '../../assets/SVG Logos/github-light-mode.svg';
import openaiLight from '../../assets/SVG Logos/openai-light-mode.svg';
import resendLight from '../../assets/SVG Logos/resend-light-mode.svg';
import amazonLight from '../../assets/SVG Logos/amazon-web-services-light-mode.svg';
import vercelLight from '../../assets/SVG Logos/vercel-light-mode.svg';

import './LogoMarquee.css';

const LOGOS = [
  { name: 'Next.js',     dark: nextjsDark,  light: nextjsLight },
  { name: 'Claude Code', dark: claudeCode,  light: claudeCode  },
  { name: 'Cursor',      dark: cursorDark,  light: cursorLight },
  { name: 'Expo',        dark: expoDark,    light: expoLight   },
  { name: 'Supabase',    dark: supabase,    light: supabase    },
  { name: 'GitHub',      dark: githubDark,  light: githubLight },
  { name: 'TypeScript',  dark: typescript,  light: typescript  },
  { name: 'React',       dark: reactjs,     light: reactjs     },
  { name: 'OpenAI',      dark: openaiDark,  light: openaiLight },
  { name: 'Resend',      dark: resendDark,  light: resendLight },
  { name: 'Python',      dark: python,      light: python      },
  { name: 'Node.js',     dark: nodejs,      light: nodejs      },
  { name: 'Amazon',      dark: amazonDark,  light: amazonLight },
  { name: 'Vercel',      dark: vercelDark,  light: vercelLight },
];

export default function LogoMarquee() {
  const { theme } = useTheme();

  return (
    <div
      className="marquee-wrapper"
      aria-label="Tech stack logos"
      role="region"
      style={{ marginTop: '15px' }}
    >
      <div className="marquee-track">
        {LOGOS.map((logo) => (
          <div key={logo.name} className="marquee-logo-item">
            <img
              src={theme === 'dark' ? logo.dark : logo.light}
              alt={logo.name}
              draggable="false"
            />
          </div>
        ))}
        {LOGOS.map((logo) => (
          <div
            key={`${logo.name}-dup`}
            className="marquee-logo-item"
            data-duplicate="true"
            aria-hidden="true"
          >
            <img
              src={theme === 'dark' ? logo.dark : logo.light}
              alt=""
              role="presentation"
              draggable="false"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
